import {
  FlowNotableObject,
  FlowProviderActivationMode,
  FlowUpdateNotableObjectConfigSchema,
} from 'flow-schema';
import { z } from 'zod';

import { isTruthy } from '../../../utils.js';
import { ExportFingerprintNote } from '../../user/preferences.js';
import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';

export { ExportFingerprintNote };

export const UpdateNotableObjectBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.UpdateNotableObject),
  config: FlowUpdateNotableObjectConfigSchema.superRefine((data, ctx) => {
    if (data.notableObject === FlowNotableObject.Provider) {
      if (
        data.providerActivationMode === FlowProviderActivationMode.Activate &&
        !isTruthy(data.providerUserId?.trim())
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Provider User ID is required when Provider Activation Mode is set to Activate',
          path: ['providerUserId'],
        });
      }
    }
  }),
});

export type UpdateNotableObjectBlock = z.infer<typeof UpdateNotableObjectBlockSchema>;
